import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { useSelector } from 'react-redux';

// Layout
import MainLayout from './components/layout/MainLayout';
import ProtectedRoute from './components/common/ProtectedRoute';
import AdminRoute from './components/common/AdminRoute';

// Pages publiques
import LoginPage from './pages/LoginPage';
import ResetPasswordPage from './pages/ResetPasswordPage';

// Pages protégées
import DashboardPage from './pages/DashboardPage';
import ClientsPage from './pages/ClientsPage';
import ClientDetailPage from './pages/ClientDetailPage';
import ClientFormPage from './pages/ClientFormPage';
import CoachingsPage from './pages/CoachingsPage';
import CoachingDetailPage from './pages/CoachingDetailPage';
import CoachingFormPage from './pages/CoachingFormPage';
import EcheancesPage from './pages/EcheancesPage';
import FormationsPage from './pages/FormationsPage';
import NotificationsPage from './pages/NotificationsPage';
import DocumentsPage from './pages/DocumentsPage';
import WelcomePage from './pages/WelcomePage';
import RapportsPage from './pages/RapportsPage';
import ProfilPage from './pages/ProfilPage';

// Pages Admin uniquement
import UtilisateursPage from './pages/admin/UtilisateursPage';
import AuditPage from './pages/admin/AuditPage';
import ParametresPage from './pages/admin/ParametresPage';

export default function App() {
  const { isAuthenticated } = useSelector(s => s.auth);

  return (
    <Router>
      <Routes>
        {/* Publiques */}
        <Route path="/login" element={
          isAuthenticated ? <Navigate to="/dashboard" replace /> : <LoginPage />
        } />
        <Route path="/reset-password/:token?" element={<ResetPasswordPage />} />
        <Route path="/welcome" element={<WelcomePage />} />

        {/* Protégées */}
        <Route element={<ProtectedRoute />}>
          <Route element={<MainLayout />}>
            <Route path="/dashboard"               element={<DashboardPage />} />
            <Route path="/clients"                 element={<ClientsPage />} />
            <Route path="/clients/nouveau"         element={<ClientFormPage />} />
            <Route path="/clients/:id"             element={<ClientDetailPage />} />
            <Route path="/clients/:id/modifier"    element={<ClientFormPage />} />
            <Route path="/coachings"               element={<CoachingsPage />} />
            <Route path="/coachings/nouveau"       element={<CoachingFormPage />} />
            <Route path="/coachings/:id/modifier"  element={<CoachingFormPage />} />
            <Route path="/coachings/:id"           element={<CoachingDetailPage />} />
            <Route path="/echeances"               element={<EcheancesPage />} />
            <Route path="/formations"              element={<FormationsPage />} />
            <Route path="/documents"               element={<DocumentsPage />} />
            <Route path="/alertes"                 element={<Navigate to="/notifications" replace />} />
            <Route path="/notifications"           element={<NotificationsPage />} />
            <Route path="/profil"                  element={<ProfilPage />} />

            {/* Admin uniquement */}
            <Route element={<AdminRoute />}>
              <Route path="/rapports"     element={<RapportsPage />} />
              <Route path="/utilisateurs" element={<UtilisateursPage />} />
              <Route path="/audit"        element={<AuditPage />} />
              <Route path="/parametres"   element={<Navigate to="/dashboard" replace />} />
            </Route>
          </Route>
        </Route>

        {/* Redirection par défaut */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>

      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        theme="light"
      />
    </Router>
  );
}
